export default __webpack_public_path__ + "static/media/pic2.77f336ea.jpg";